<template>
  <div class="tableDateArea">
    <div class="input-box">
      <input v-model.lazy="inputValue" type="text" autocomplete="off" :disabled="status"/>
      <label>{{ $t('search.query') }}</label>
    </div>
  </div>
</template>

<script>
export default {
  name: "SearchArea",
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    status: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    inputValue: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("searchData", value);
      }
    }
  }
};
</script>
